export default function WiFiSignal0() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      fill="none"
      viewBox="0 0 24 18"
    >
      <g id="wifi-online 1" clipPath="url(#clip0_57_150)">
        <g id="Layer_1-2">
          <path
            id="Vector"
            fill="#CFCFCF"
            d="M17.637 11.887a8.1 8.1 0 0 0-5.334-1.991 8.1 8.1 0 0 0-5.333 1.998.18.18 0 0 0-.064.135c0 .05.014.107.05.15l.917 1.087c.071.086.206.1.292.022a6.27 6.27 0 0 1 4.153-1.565c1.593 0 3.044.59 4.153 1.565a.21.21 0 0 0 .291-.022l.918-1.088a.2.2 0 0 0-.021-.284z"
          ></path>
          <path
            id="Vector_2"
            fill="#CFCFCF"
            d="M20.624 8.331a12.94 12.94 0 0 0-8.313-3.008c-3.165 0-6.06 1.13-8.321 3.008a.2.2 0 0 0-.071.135.2.2 0 0 0 .05.15l.917 1.088c.071.085.2.1.285.028a11.16 11.16 0 0 1 7.147-2.582 11.1 11.1 0 0 1 7.14 2.582.197.197 0 0 0 .284-.028l.918-1.089a.197.197 0 0 0-.029-.284z"
          ></path>
          <path
            id="Vector_3"
            fill="#CFCFCF"
            d="M23.59 4.797A17.85 17.85 0 0 0 12.254.75C7.95.75 4.06 2.25.989 4.747a.16.16 0 0 0-.05.064.14.14 0 0 0-.021.078c0 .028 0 .057.007.078.007.029.021.05.035.071l.918 1.088c.071.086.199.1.284.029a15.96 15.96 0 0 1 10.099-3.577c3.826 0 7.389 1.358 10.162 3.627a.203.203 0 0 0 .285-.029l.917-1.088a.197.197 0 0 0-.028-.284z"
          ></path>
          <path
            id="Vector_4"
            fill="#CFCFCF"
            d="M10.654 15.89a1.625 1.625 0 0 0 1.628 1.63 1.625 1.625 0 0 0 1.629-1.63 1.625 1.625 0 0 0-1.629-1.628 1.625 1.625 0 0 0-1.628 1.629"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_57_150">
          <path fill="#fff" d="M.91.75h22.75v16.762H.91z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
